<div class="container-fluid d-flex justify-content-center align-items-center w-100">
	<div class="card m-0 shadow-sm border-white rounded my-auto w-100">
		<app-header></app-header>
		<div class="card-body w-100">
			<div class="d-flex flex-column justify-content-between align-items-center custom-card-height">
				<app-package-card [product]="package"></app-package-card>

				<div class="text-center mt-auto mb-3 col-sm=12 col-md-4">
					<button [disabled]="!continuePossible" type="button" class="btn btn-angola"
						(click)="continue()">{{'continue' | translate}}</button>
				</div>
			</div>
		</div>
	</div>
</div>